export const trackSignUp = () => {
  // Meta
  if (window.fbq) {
    window.fbq("track", "CompleteRegistration");
  }

  // LinkedIn
  if (window.lintrk) {
    window.lintrk("track", {
      conversion_id: 23737532,
    });
  }
};

export const trackSignIn = () => {
  // Meta
  if (window.fbq) {
    window.fbq("track", "Lead");
  }

  // LinkedIn
  if (window.lintrk) {
    window.lintrk("track", {
      conversion_id: 23737540,
    });
  }
};
